"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeWidgets_de_de = void 0;
function backofficeWidgets_de_de() {
    return {
        "backoffice.widgets.add": "Widget hinzufügen",
        "backoffice.widgets.notes": "Notizen",
        "backoffice.widgets.users": "Benutzer",
        "backoffice.widgets.configuration.widget": "Widget Konfiguration",
        "backoffice.widgets.configuration.more": "Weitere Einstellungen",
        "backoffice.widgets.configuration.visual": "Ansicht",
        "backoffice.widgets.configuration.actions": "Aktionen",
        "backoffice.widgets.configuration.actionsdescription": "Eine Url kann für eine Weiterleitung zu einer anderen Seite verwendet werden.",
        "backoffice.widgets.todo.opentasks": "Offene Aufgaben",
        "backoffice.widgets.todo.completedtasks": "Erledigte Aufgaben",
        "backoffice.widgets.todo.addnewtask": "Neue Aufgabe hinzufügen...",
        "backoffice.widgets.todo.notaskscreated": "Es wurden noch keine Aufgaben erstellt.",
        "backoffice.widgets.immoscout24.nogroup": "Keine Gruppe wurde konfiguriert.",
        "backoffice.widgets.immoscout24.error": "Es können aktuell keien Immobilien angezeigt werden.",
        "backoffice.widgets.immoscout24.nolistings": "Derzeit werden keine Immobilien angeboten.",
        "backoffice.widgets.immoscout24.hearmore": "Mehr erfahren",
        "backoffice.widgets.immoscout24.price": "Preis",
        "backoffice.widgets.immoscout24.rooms": "Zimmer",
        "backoffice.widgets.immoscout24.livingspace": "Fläche",
        "backoffice.widgets.immoscout24.missingconfig": "Konfiguration konnte nicht gefunden werden",
        "backoffice.widgets.tags.dashboard.label": "Dashboard",
        "backoffice.widgets.tags.company-dashboard.label": "Firmen Dashboard",
        "backoffice.widgets.tags.project-dashboard.label": "Projekt Dashboard",
        "backoffice.widgets.tags.cms.label": "Projekt Dashboard",
        "backoffice.widgets.tags.application.label": "Applikationen",
        "backoffice.widgets.tags.personal-dashboard.label": "Persönliches Dashboard",
        "backoffice.widgets.tags.cbo.label": "Benutzerdefinierte Backoffices",
        "backoffice.widgets.tags.container.label": "Kontainer",
        "backoffice.widgets.tags.icon.label": "Kleines Icon"
    };
}
exports.backofficeWidgets_de_de = backofficeWidgets_de_de;
